module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"drop":"Drop above or click to select from pc","title":"Add image","add":"Add","or":"Or","url":"Add image URL"},"pt-BR":{"drop":"Arraste ou clique para selecionar do computador","title":"Adicionar imagem","add":"Adicionar","or":"Ou","url":"Adicione a URL da imagem"}}')
  delete Component.options._Ctor
}
